import { Component, OnInit } from '@angular/core';

import { PageEvent } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';

// Models
import { MetaData } from 'src/app/platform/models/utils';
import { ProceduresData } from 'src/app/modules/procedures/models/procedures';
import { ScreenLoaderData } from 'src/app/platform/components/ui-screen-loader/ui-screen-loader.model';

// Services
import { UiService } from 'src/app/platform/services/ui.service';
import { ProceduresService } from 'src/app/modules/procedures/procedures.service';
import { ListExportService } from 'src/app/platform/services/platform.service';

// Components
import { ProceduresDetailComponent } from 'src/app/modules/procedures/views/procedures-detail/procedures-detail.component';

@Component({
  selector: 'app-procedures-list',
  templateUrl: './procedures-list.component.html',
  styleUrls: ['./procedures-list.component.scss']
})
export class ProceduresListComponent implements OnInit {
  public filters: any = {
    type: '',
    status: '',
    dateStart: { start: '', end: ''},
    dateEnd: { start: '', end: ''}
  };
  public filterProceduresStatus: MetaData[] = [];
  public procedures: ProceduresData[] = [];
  public proceduresTotal = 0;
  public proceduresPage = 1;
  public proceduresPageSize = 5;
  public proceduresUpdating = false;
  public proceduresInitStatus = false;
  public errors = {
    load: new ScreenLoaderData('Cargando gestiones', 'Estamos buscando la información de tus gestiones realizadas.', 'add_task', true),
    empty: new ScreenLoaderData('No existen gestiones realizadas', 'Aun no realizaste ninguna gestion. Cuando realices una prodras verla aqui.', 'help_outline'),
    error: new ScreenLoaderData('Ocurrió un error al intentar cargar las gestiones', 'No pudimos obtener tus gestiones, estamos trabajando para solucionar este problema. Por favor intenta revisar nuevamente mas tarde.', 'highlight_off'),
  };

  constructor(
    private uiService: UiService,
    private debitDialog: MatDialog,
    private proceduresService: ProceduresService,
    private listExportService: ListExportService,
  ) {
    this.proceduresService.proceduresIsUpdate.subscribe((status) => {
      if (status) {
        this.proceduresChange();
      }
    });
  }

  ngOnInit(): void {
    this.uiService.screenLoaderSet(this.errors.load);

    this.proceduresLoad(this.proceduresPage, this.proceduresPageSize).then((success) => {
      if (success.registersTotal > 0) {
        this.proceduresInitStatus = true;
        this.procedures = success.registers;
        this.proceduresTotal = success.registersTotal;
        this.proceduresPage = success.page;
      } else {
        this.uiService.screenLoaderSet(this.errors.empty);
      }
    }).catch(() => {
      this.uiService.screenLoaderSet(this.errors.error);
    });

    this.proceduresService.proceduresStatusGet().then((success) => {
      this.filterProceduresStatus = success.result;
    }).catch((error) => {
      this.filterProceduresStatus = [new MetaData(0, 'Filtro no disponible')];
    });
  }

  private proceduresLoad(page: number | null = null, limit: number | null = null, filters: any | null = null): Promise<any> {
    return new Promise((resolve, reject) => {
      this.proceduresService.proceduresUpdate(false);

      this.proceduresService.proceduresGet(page, limit, filters).then((success) => {
        resolve(success.result);
      }).catch(() => {
        reject(false);
      });
    });
  }

  private proceduresChange(): void {
    this.proceduresUpdating = true;

    this.proceduresLoad(this.proceduresPage, this.proceduresPageSize, this.filters).then((success) => {
      this.proceduresUpdating = false;

      if (success.registersTotal > 0) {
        this.procedures = success.registers;
        this.proceduresTotal = success.registersTotal;
        this.proceduresPage = success.page;
      } else {
        this.procedures = [];
      }
    }).catch((error) => {
      this.proceduresUpdating = false;
      this.procedures = [];
      this.uiService.showSnackBar(this.errors.error.message);
    });
  }

  onPaginationChange(event: PageEvent): void {
    this.proceduresPage = event.pageIndex + 1;
    this.proceduresPageSize = event.pageSize;

    this.proceduresChange();
  }

  onFilterSelect(filter: string, value?: any): void {
    if (typeof this.filters[filter] !== 'undefined') {
      let update = true;

      if (filter === 'dateStart' || filter === 'dateEnd') {
        if (this.filters[filter].end === '' || this.filters[filter].end === null) {
          update = false;
        }

        if (value === '') {
          this.filters[filter] = {start: '', end: ''};
          update = true;
        }
      } else {
        this.filters[filter] = value;
      }

      if (update) {
        this.proceduresPage = 1;

        this.proceduresChange();
      }
    }
  }

  onViewDetail(procedure: ProceduresData): void {
    this.debitDialog.open(ProceduresDetailComponent, {
      width: '350px',
      data: { detail: procedure.detail }
    });
  }

  onExport(type: string): void {
    this.uiService.showSpinner(true);

    this.proceduresLoad(1, null, this.filters).then((success) => {
      if (this.procedures.length > 0) {
        const items: any = [];

        success.registers.forEach((item: any) => {
          items.push({
            tipo: item.type,
            estado: item.status,
            motivo: item.reason,
            detalle: item.detail,
            medio: item.medium,
            fechaInicio: item.dateStart,
            fechaFinal: item.dateEnd
          });
        });

        if (items.length > 0) {
          const structure = [
            {header: 'Tipo', body : 'tipo'},
            {header: 'Estado', body : 'estado'},
            {header: 'Motivo', body : 'motivo'},
            {header: 'Detalle', body : 'detalle'},
            {header: 'Medio', body : 'medio'},
            {header: 'Fecha de inicio', body : 'fechaInicio'},
            {header: 'Fecha de fin', body : 'fechaFinal'}
          ];
          console.log(items);
          this.listExportService.downloadFile(type, 'Listado de gestiones', structure, items).then((response) => {
            this.uiService.showSpinner(false);
          });
        }
      } else {
        this.uiService.showSpinner(false);
        this.uiService.showSnackBar('No existen registros para generar la exportación');
      }
    }).catch((error) => {
      this.uiService.showSpinner(false);
      this.uiService.dialogShow('Ups!', 'No es posible generar la exportación en este momento. Estamos trabajando para solucionar el inconveniente.', 'alert');
    });
  }
}
